import React from "react";

function SecondaryButton({
  children,
  onClick,
  style = {}
}) {
  return (
    <button
      onClick={onClick}
      style={{
        background: "transparent",
        color: "#002147",
        border: "2px solid #002147",
        padding: "14px 30px",
        borderRadius: "999px",
        fontWeight: 600,
        cursor: "pointer",
        transition: "0.3s",
        ...style
      }}
    >
      {children}
    </button>
  );
}

export default SecondaryButton;